export default __webpack_public_path__ + "trending-up-a555e3629ce4f8d2929751cb5b15780a.svg";